module.exports = __webpack_public_path__ + "img/bg-small-schedule.96193cce.png";